import { render, staticRenderFns } from "./testpage.vue?vue&type=template&id=547a89c6&scoped=true"
import script from "./testpage.vue?vue&type=script&lang=js"
export * from "./testpage.vue?vue&type=script&lang=js"
import style0 from "./testpage.vue?vue&type=style&index=0&id=547a89c6&prod&lang=scss&scoped=true"
import style1 from "./testpage.vue?vue&type=style&index=1&id=547a89c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a89c6",
  null
  
)

export default component.exports